import React from 'react';
import { Avatar, TextStyle } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';

export const SourceCell = (props) => {
  const { cell } = props;
  const { origin } = cell?.row?.original;
  const colEntity = cell.column?.field?.id;

  return (
    <>
      {colEntity == 'actionVersion.userActionConfig.addedBy.name' &&
        (origin?.source == 'User' ? (
          <div className="fx actr g5">
            <div className="fx actr">
              <Avatar size="xs" initials={origin?.name?.[0]} />
            </div>
            <div className="ellipsis">
              <TextStyle>{origin?.name}</TextStyle>
            </div>
          </div>
        ) : (
          <TextStyle variation="subdued">NA</TextStyle>
        ))}

      {colEntity == 'actionVersion.policyActionConfig.policy.name' &&
        (origin?.source == 'Policy' ? (
          <div className="fx actr g5">
            <div className="fx actr">
              <SVGIcon name="PolicyLight" />
            </div>
            <div className="ellipsis">
              <TextStyle>{origin?.name}</TextStyle>
            </div>
          </div>
        ) : (
          <TextStyle variation="subdued">NA</TextStyle>
        ))}
    </>
  );
};
